export const GET_INTERNSHIP_STRUCTURES = "GET_INTERNSHIP_STRUCTURES"
export const GET_INTERNSHIP_STRUCTURES_FAIL = "GET_INTERNSHIP_STRUCTURES_FAIL"
export const GET_INTERNSHIP_STRUCTURES_SUCCESS = "GET_INTERNSHIP_STRUCTURES_SUCCESS"

export const ADD_NEW_INTERNSHIP_STRUCTURE = "ADD_NEW_INTERNSHIP_STRUCTURE"
export const ADD_INTERNSHIP_STRUCTURE_SUCCESS = "ADD_INTERNSHIP_STRUCTURE_SUCCESS"
export const ADD_INTERNSHIP_STRUCTURE_FAIL = "ADD_INTERNSHIP_STRUCTURE_FAIL"

export const UPDATE_INTERNSHIP_STRUCTURE = "UPDATE_INTERNSHIP_STRUCTURE"
export const UPDATE_INTERNSHIP_STRUCTURE_SUCCESS = "UPDATE_INTERNSHIP_STRUCTURE_SUCCESS"
export const UPDATE_INTERNSHIP_STRUCTURE_FAIL = "UPDATE_INTERNSHIP_STRUCTURE_FAIL"

export const DELETE_INTERNSHIP_STRUCTURE = "DELETE_INTERNSHIP_STRUCTURE"
export const DELETE_INTERNSHIP_STRUCTURE_SUCCESS = "DELETE_INTERNSHIP_STRUCTURE_SUCCESS"
export const DELETE_INTERNSHIP_STRUCTURE_FAIL = "DELETE_INTERNSHIP_STRUCTURE_FAIL"





